import React from "react";
import TodoKeep from "./Todokeep";
import { useSelector } from "react-redux";
import styled from "styled-components";

const BlockAllTodo = () => {
  const todos = useSelector((state) => state.todo.todos);

  return (
    <Todos>
      {todos &&
        todos.map((todo, index) => (
          <TodoKeep
            key={index}
            id={todo.id}
            title={todo.title}
            description={todo.description}
          />
        ))}
    </Todos>
  );
};

export default BlockAllTodo;

const Todos = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 30px 40px;
  margin-top: 30px;
  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;
